import "./ProfileOrders.scss";
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { getUserOrders } from "../../../../api/account";
import { Link } from "react-router-dom";
import images from "../../../../ressources/images";
import InsLoader from "../../../../components/InsLoader/InsLoader";
import InsButton from "../../../../components/InsButton/InsButton";

const ProfileOrders = (props) => {
    const { t } = props;
    const [orders, setOrders] = useState([]);
    const [loader, setLoader] = useState(true);
    const [nbrPage, setNbrPage] = useState(1);
    const [seeMore, setSeeMore] = useState(true);

    const closeOrders = () => {
        const { history, location } = props;
        if (location.state && location.state.goBack) {
            history.goBack();
        } else {
            history.replace("/");
        }
    };

    const loadmore = () => {
        setNbrPage(nbrPage + 1);
    };

    useEffect(() => {
        const getOrders = () => {
            getUserOrders(nbrPage, 6).then((data) => {
                setOrders((prevOrders) => [...prevOrders, ...data]);
                setLoader(false);

                if (data.length < 6) {
                    setSeeMore(false);
                }
            });
        };
        getOrders();
    }, [nbrPage]);

    return (
        <div className="orders_page">
            <div className="header">
                <div className="close" onClick={closeOrders}>
                    <img src={images.closeCross} alt="" />
                </div>
                <div className="title">{t("my_orders")}</div>
                <img src={images.orders} className="orders" alt="" />
            </div>

            <div
                className="orders_container default-layout--min-height"
                id="orders_container"
            >
                {loader ? (
                    <InsLoader />
                ) : (
                    <>
                        <table id="orders_table">
                            <thead>
                            <tr>
                                <td>{t("order")}</td>
                                <td>{t("status")}</td>
                                <td>{t("nbr_tracking")}</td>
                            </tr>
                            </thead>
                            <tbody>
                            {orders.length ? (
                                orders.map((order) => (
                                    <Link
                                        to={{
                                            pathname: "/profile/order/" + order.number,
                                            state: { transitionName: "slide_in" },
                                        }}
                                    >
                                        <tr key={order.number}>
                                            <td>
                                                <div className="order_nbr">N° {order.number}</div>
                                                <div className="order_date">{order.date}</div>
                                            </td>
                                            <td>
                                                <div className="order_status">
                                                    {order.status === "refunded" ? t("refunded") : t("confirmed")}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="num_tracking">
                                                    {order.status === "refunded" ? <span className="empty_url">-</span> : (
                                                        <>
                                                            {order.trackingUrl ? (
                                                                <a
                                                                    href={order.trackingUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {order.trackingUrl}
                                                                </a>
                                                            ) : (
                                                                <span className="no_trackingurl">{t("No_Tracking_Number_Available")}</span>
                                                            )}
                                                        </>)}
                                                </div>
                                                <div className="right_arrow"></div>
                                            </td>
                                        </tr>
                                    </Link>
                                ))
                            ) : (
                                <tr>
                                    <td className="no_orders">{t("no_orders")}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        {seeMore && (
                            <InsButton onClick={loadmore} text={t("see_more")} type="default" />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default withTranslation()(ProfileOrders);